import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '@services/auth.service';
import { JwtService } from '@services/jwt.service';
import { GrantService } from '@services/grant.service';
import { Grant } from '@models/grant.model';
import { BackendValidationError } from '@models/backend-validation-error';
import { Message } from '@models/message';

@Component({
    selector: 'auth-login',
    standalone: true,
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    imports: [
        CommonModule,
        RouterLink,
        ReactiveFormsModule,
        MatGridListModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule, 
        MatIconModule,
    ],
})
export class LoginComponent {

    form : FormGroup;
    hide : boolean = true;

    constructor(
        private builder: FormBuilder,
        private authService: AuthService, 
        private grantService: GrantService, 
        private router: Router) {

        this.form = this.builder.group({
            usr:   this.builder.nonNullable.control<string>('', [Validators.required, Validators.email,]),
            pwd:   this.builder.nonNullable.control<string>('', [Validators.required,]),
        });
        
    }

    login() : void {

        if (this.form.invalid) {
            //validation feedback directly in component template
            return
        }

        const usr: string= this.form.value.usr;
        const pwd: string= this.form.value.pwd;

        this.authService.get(usr, pwd).subscribe({
            next: (jwt) => {
                JwtService.save(jwt)
            },
            error: (err) => {
                const error = new BackendValidationError(err);
                error?.setFormErrors(this.form);
                console.log(error);
            },
            complete: () => {
                this.grants();
            }
        });
    }

    grants() : void {

        this.grantService.fetch().subscribe({
            next: (resp) => {
                GrantService.save(<Grant[]>resp.body);
            },
            error: (err) => {
                let m = <Message>err.error;
                console.log(m);
                JwtService.clear();
                this.router.navigateByUrl('/login');
            },
            complete: () => {
                this.router.navigateByUrl('/');
            }
        });
    }
}
